export const TrusteeKeysWithLogo = [
  'fiscalteam',
  // 'anouk',
  'bob',
];
